import {
    SanctionEventDetail,
    SanctionEventType,
} from "../../../api/sanctionEvents";
import { CreditFacility } from "../../../api/credit_accounts";
import {
    FacilityCategory,
    getFacilityCategoryForCreditFacility,
} from "../../creditAccounts/logic/creditAccountMappings";

export interface EnrichedSanctionEventDetail {
    raw: SanctionEventDetail;
    credit_facility: CreditFacility;
    facility_category: FacilityCategory;
}

export type CreditFacilityLookup = (
    loanAccountNumber: string,
) => CreditFacility;

export const SANCTION_EVENT_TYPE_LABELS: Record<SanctionEventType, string> = {
    [SanctionEventType.FRESH_SANCTION]: "Fresh Sanction",
    [SanctionEventType.TAKEOVER_SANCTION]: "Takeover Sanction",
    [SanctionEventType.ENHANCEMENT]: "Enhancement",
    [SanctionEventType.RENEW_AND_ENHANCEMENT]: "Renewal & Enhancement",
    [SanctionEventType.REVIEW_OR_RENEWAL]: "Review or Renewal",
    [SanctionEventType.OPERATIONAL_REVIEW]: "Operational Review",
    [SanctionEventType.RENEWAL_WITH_REDUCTION]: "Renewal & Reduction",
    [SanctionEventType.PARTIAL_TAKEOVER_AND_ENHANCEMENT]:
      "Partial Takeover & Enhancement",
    [SanctionEventType.SANCTION_WITH_SUB_LIMIT_ALLOCATION]:
      "Sanction with Sub-limit Allocation",
    [SanctionEventType.RESTRENGTHENING_AND_RESTRUCTURE]:
      "Restrengthen & Restructure",
};

export const SANCTION_EVENT_TYPE_OPTIONS = Object.values(
    SanctionEventType,
  ).map((value) => ({
    value,
    name: SANCTION_EVENT_TYPE_LABELS[value],
}));

export const enrichSanctionEventDetail = (
    detail: SanctionEventDetail,
    getCreditFacilityForLoanAccount: CreditFacilityLookup,
): EnrichedSanctionEventDetail => {
    const creditFacility =
      getCreditFacilityForLoanAccount(detail.loan_account_number)

    return {
      raw: detail,
      credit_facility: creditFacility,
      facility_category: getFacilityCategoryForCreditFacility(creditFacility),
    };
};

export const enrichSanctionEventDetails = (
    details: SanctionEventDetail[],
    getCreditFacilityForLoanAccount: CreditFacilityLookup,
): EnrichedSanctionEventDetail[] =>
    details.map((detail) =>
      enrichSanctionEventDetail(detail, getCreditFacilityForLoanAccount),
    );

export const filterDetailsByFacilityCategory = (
    details: EnrichedSanctionEventDetail[],
    category: FacilityCategory,
) => details.filter((detail) => detail.facility_category === category);
